import { createSelector } from 'redux-starter-kit';
import { productsSlugs } from 'consts/products';

export default {
  briefing: createSelector(['products.selected.briefing_template']),
  selected: createSelector(['products.selected']),
  list: createSelector(['products.list']),
  isBrandValuatorProduct: createSelector(['products.selected'], ({ slug }) => {
    const isBrandValuatorProduct = slug === productsSlugs.BRAND_VALUATOR;

    return isBrandValuatorProduct;
  }),
};
